import SavedFilter from "../listing/SavedFilter"
import {SavedFilterDto} from "../listing/SavedFilter"
import { SHORTCUT_ACTION_TYPE } from "./ShortcutAction"

export namespace SHORTCUT_TYPE {
    export const FILTER = "shortcut-filter"
    export const ACTION = "shortcut-action"
 }

export type SHORTCUT_TYPE = typeof SHORTCUT_TYPE[keyof typeof SHORTCUT_TYPE]


export type ShortcutAttributes = {
    name: string
    color: string
    rank: number
    cloneId: string
    projectId: string
    savedFilter: SavedFilterDto
    actionType: SHORTCUT_ACTION_TYPE
}

export type ShortcutDto = {
    id: string
    type: SHORTCUT_TYPE 
    attributes: ShortcutAttributes
}

export default class Shortcut {
    private dto: ShortcutDto
    private savedFilter: SavedFilter

    constructor(dto: ShortcutDto) {
        this.dto = dto
        this.savedFilter = new SavedFilter((dto.attributes as ShortcutAttributes).savedFilter)
    }

    isLoaded(): boolean {
        return this.getId() != "" && [SHORTCUT_TYPE.FILTER, SHORTCUT_TYPE.ACTION].includes(this.dto.type)
    }

    getId(): string {
        return this.dto.id
    }

    getName(): string {
        return this.dto.attributes.name
    }

    getColor(): string {
        return this.dto.attributes.color
    }

    getCloneId(): string {
        return this.dto.attributes.cloneId
    }

    getProjectId(): string {
        return this.dto.attributes.projectId
    }

    getRank(): number {
        return this.dto.attributes.rank
    }

    setRank(rank: number) {
        this.dto.attributes.rank = rank
    }

    getSavedFilter(): SavedFilter {
        return this.savedFilter
    }

    getSavedFilterId(): string {
        return this.savedFilter.getId()
    }

    getSavedFilterName() {
        return this.savedFilter.getName()
    }

    getSavedFilterListingType() {
        return this.savedFilter.getListingType()
    }

    getSavedFilterDecodedContent() {
        return this.savedFilter.getDecodedContent()
    }

    getDto(): ShortcutDto {
        return this.dto
    }

    getActionName(): SHORTCUT_ACTION_TYPE {
        return this.dto.attributes.actionType
    }

    getShortcutType(): SHORTCUT_TYPE {
        return this.dto.type
    }
}


// WEBPACK FOOTER //
// ./src/state/shortcut/Shortcut.ts